const map = {
	"./": 53937,
	"./card": 61195,
	"./card.jsx": 61195,
	"./cardList": 33159,
	"./cardList.jsx": 33159,
	"./createEndpoint": 29906,
	"./createEndpoint.jsx": 29906,
	"./index": 53937,
	"./index.jsx": 53937,
	"./nodeConfig": 88367,
	"./nodeConfig.jsx": 88367,
	"./project": 81322,
	"./project.jsx": 81322,
	"./service": 36416,
	"./service.jsx": 36416,
	"./styles.less": 8758,
	"./summary": 55117,
	"./summary.jsx": 55117
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85637;